<template>
  <div class="pageStyle">
    <div class="header">
      <!-- 头像名字 -->
      <div class="item">
        <div class="left">
          <div>
            <img :src="channelInfo.headImgUrl" alt="" />
          </div>
          <div>
            <span>{{ channelInfo.name }}</span>
            <span>{{ channelInfo.phone }}</span>
          </div>
        </div>
        <div class="rigth">
          <!-- <van-icon name="setting-o" color="white" size="6vw" /> -->
        </div>
      </div>
      <!-- 用户数据 -->
      <div class="item">
        <div class="bg">
          <div>
            <span>今日进件</span><span>{{ channelCenterInfo.totalOrder }}</span>
          </div>
          <div>
            <span>今日出额</span
            ><span>{{ channelCenterInfo.totalCreditLine }}</span>
          </div>
          <div>
            <span>客户总数</span
            ><span>{{ channelCenterInfo.totalCustomer }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bg">
        <!-- 用户功能 -->
        <div class="item">
          <div class="title">
            <div class="left">
              <div><span></span></div>
              <div>个人工具</div>
            </div>
          </div>
          <div class="bg-content">
            <div
              v-for="(item, index) in menuData1"
              :key="index"
              @click="switchName(item.url)"
            >
              <img :src="item.icon" alt="" /><span>{{ item.name }}</span>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
            <div class="left">
              <div><span></span></div>
              <div>辅助工具</div>
            </div>
          </div>
          <div class="bg-content">
            <div
              v-for="(item, index) in menuData2"
              :key="index"
              @click="switchName(item.url)"
            >
              <img :src="item.icon" alt="" /><span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="signPosterShow"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      class="signPosterShow"
    >
      <div class="signPosterImg">
        <img :src="signPosterImg" alt="" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { getCurrentChannelInfo } from "@/api/login.js";
import { getXcChannelUsetCenterMsg, getSignPoster } from "@/api/userCenter.js";
import { Icon, Dialog, Toast, Notify } from "vant";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import store from "@/store";
import router from "@/router";
Vue.use(Icon);
Vue.use(Dialog);
export default {
  name: "NewPIndex",

  data() {
    return {
      signPosterShow: false,
      channelInfo: {},
      channelCenterInfo: {
        totalCustomer: "-",
        totalCreditLine: "-",
        totalOrder: "-",
      },
      menuData1: [
        {
          name: "本月政策",
          icon: "https://static.xchengtech.cn/6e397aae45424f21aec0624884341bc1.png",
          url: "policy",
        },
        {
          name: "统一进件",
          icon: "https://static.xchengtech.cn/5efd566cfd0d47418f7ea9332acd8163.png",
          url: "productSummary",
        },

        {
          name: "团队拓展",
          icon: "https://static.xchengtech.cn/1ee632f503f148f98ceafb59f6d87afa.png",
          url: "signPoster",
        },
        {
          name: "团队管理",
          icon: "https://static.xchengtech.cn/bc993c7ab75f472c89744bf20c5efc8d.png",
          url: "lowerLevelChannels",
        },
        {
          name: "结算资料",
          icon: "https://static.xchengtech.cn/340bed26b5b641998d9d9b62f3f8dc3b.png",
          url: "accountCenter",
        },
        {
          name: "办理指引",
          icon: "https://static.xchengtech.cn/6b09fff508034b1abd9af55116bc78aa.png",
          url: "operatingManual",
        },
        // {
        //   name: "车贷客户",
        //   icon: "https://static.xchengtech.cn/44d515a15a75488e82255227ea5adf52.png",
        //   url: "carLoanCustomers",
        // },
        // {
        //   name: "车贷申请",
        //   icon: "https://static.xchengtech.cn/a747f7c666f745ab82caa8ceb8847332.png",
        //   url: "carLoanApply",
        // },
        {
          name: "报告查看",
          icon: "https://static.xchengtech.cn/0d732a5a0807454d80a1c9673c2f5cf9.png",
          url: "companyRep",
        },
        {
          name: "价格码管理",
          icon: "https://static.xchengtech.cn/ed50e32a88bc4f989396885ff1efa089.png",
          url: "companyRepCodeInfo",
        },
      ],
      menuData2: [
        {
          name: "智能匹配",
          icon: "https://static.xchengtech.cn/c6ecb54f318b4e70b520462e61f06f84.png",
          url: "productFilter",
        },
        {
          name: "计算器",
          icon: "https://static.xchengtech.cn/cb05e246815c48e99b9547e9fb3f69f7.png",
          url: "calculator",
        },
        {
          name: "夹层码工具",
          icon: "https://static.xchengtech.cn/4b9cda3c410445c38b92b9b877ce89d5.png",
          url: "layerCode",
        },
        // {
        //   name: "数据采集",
        //   icon: "https://static.xchengtech.cn/2c8d507b6aca408b9f6108bab2f83519.png",
        //   url: "",
        // },
        {
          name: "设置",
          icon: "https://static.xchengtech.cn/09abf7008f58457382bed00672201c7e.png",
          url: "set",
        },
      ],
      signPosterImg: "",
    };
  },

  mounted() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    // 获取渠道用户信息
    getCurrentChannelInfo()
      .then((res) => {
        this.channelInfo = res;
      })
      .catch((err) => {
        console.log("err", err);
        Toast.clear();
      });
    // 获取渠道业务信息
    getXcChannelUsetCenterMsg()
      .then((res) => {
        Toast.clear();
        this.channelCenterInfo = res;
      })
      .catch((err) => {
        console.log("err", err);
        Toast.clear();
      });
  },
  created() {},
  methods: {
    switchName(name) {
      console.log("name", name);
      if (name)
        switch (name) {
          case "calculator":
            this.toUrl("https://independentpage.xchengtech.cn/calculator.html");
            break;
          case "policy":
            this.toUrl("https://www.kdocs.cn/l/cd5CtPX61wMt");
            break;
          case "signPoster":
            this.toGetSignPoster();
            break;
          case "carLoanApply":
            let domain = "https://apply.xchengtech.cn";
            let url =
              domain +
              "/#/carLoan?channelId=" +
              this.channelInfo.id +
              "&depName=" +
              this.channelInfo.depName;
            console.log("url", url);
            this.toUrl(url);
            break;
          default:
            this.$router.push({ path: "/" + name });
            break;
        }
    },
    toUrl(url) {
      console.log("utl", url);
      window.location.href = url;
    },
    divToImgTips() {
      Notify({ type: "primary", message: "请长按图片保存" });
      // Toast("请长按图片保存");
    },
    // 获取注册海报
    toGetSignPoster() {
      if (this.signPosterImg) {
        this.signPosterShow = !this.signPosterShow;
      } else {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        getSignPoster()
          .then((res) => {
            Toast.clear();
            this.signPosterImg = res.url;
            this.signPosterShow = !this.signPosterShow;
          })
          .catch((err) => {
            console.log("err", err);
            Toast.clear();
          });
      }
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/userCenter/index.vue